module.exports = __webpack_public_path__ + "img/pp.68fa4e47.png";